import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { initBlock } from './BusinessMonitoringChartsSlice';
import { getCustomerNvOrgListAsync } from './BusinessMonitoringChartsAsyncThunk';
import Search from './Partials/Search/Search';
import AdminSearch from './Partials/Search/AdminSearch';
import NavigationMenu from './Partials/NavigationMenu/NavigationMenu';
import ChartList from './Partials/ChartList/ChartList';

const BusinessMonitoringCharts = (props) => {
    const isAdminMode = !!props.iContent.isAdminMode?.value; 

    useEffect(() => {
        props.initBlock({ currentBlock: props.iContent });        
        if (!isAdminMode) {
           props.getCustomerNvOrgListAsync(); 
        }             
    },[]);


    return (
        <div className='business-monitoring-charts-block'>
            <div className='title'>פורטל ניטור</div>
            
            <div className='search-wrapper'>
                { isAdminMode ? <AdminSearch /> : <Search /> }
            </div>

            <div className='business-monitoring-charts-wrapper'>
                {
                    ((isAdminMode && props.nvItemList.length > 0) || !isAdminMode) &&
                    <div className='business-monitoring-charts'>

                        <div className='navigation-wrapper'>
                            <NavigationMenu nvItemList={props.nvItemList} />
                        </div>

                        <div className='chart-list-wrapper'>
                            <ChartList />
                        </div>

                    </div>
                }
            </div>

        </div>
    );

};


const mapStateToProps = (state) => {
    return {
        nvItemList: state.businessMonitoringChartsBlock.nvItemList
    };
};
  
const mapDispatchToProps = { 
    initBlock,
    getCustomerNvOrgListAsync
};
  
export default connect(mapStateToProps, mapDispatchToProps)(BusinessMonitoringCharts);